$(() => {
  // Enable bootstrap tooltips
  $('[data-toggle="tooltip"]').tooltip();
});
